import React, { useState } from "react";
import { FaFileAlt, FaComments, FaMoneyBillWave, FaGift, FaChalkboardTeacher } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./AdmissionProcess.css";
import qrImage from "../../assets/qr-code.jpg";

const AdmissionProcess = ({ headingLevel = "h2" }) => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const Heading = headingLevel;

  const handleTogglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleOpenForm = () => {
    // Navigate to the form section on the same page
    const formElement = document.getElementById("ad-form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    } else {
      // If form is on a different page, navigate to it
      navigate("/admission-form");
    }
  };

  const handlePayAndOpenForm = () => {
    setShowPopup(true);
  };

  return (
    <section className="ap-section">
      <div className="ap-container">
        <Heading className="ap-title">Montessori Teacher Training Course Process</Heading>
        <p className="ap-subtitle">Remember this process​</p>

        <div className="ap-steps-row">
          <div className="ap-step-card">
            <FaFileAlt className="ap-step-icon" />
            Fill Application Form
          </div>
          <div className="ap-step-card">
            <FaComments className="ap-step-icon" />
            Contact Counselor
          </div>
          <div className="ap-step-card">
            <FaMoneyBillWave className="ap-step-icon" />
            Pay Training Fee
          </div>
          <div className="ap-step-card">
            <FaGift className="ap-step-icon" />
            Get Student Kit
          </div>
          <div className="ap-step-card">
            <FaChalkboardTeacher className="ap-step-icon" />
            Attend Classes
          </div>
        </div>

        {/* Action Buttons */}
        <div className="ap-button-container">
          {/* <button className="ap-action-button ap-pay-button" onClick={handlePayAndOpenForm}>
            Click to Pay
          </button> */}
          <button className="ap-action-button ap-form-button" onClick={handleOpenForm}>
            Click here to Fill Application Form
          </button>
        </div>

        {/* QR Code Popup */}
        {showPopup && (
          <div className="ap-popup-overlay" onClick={handleTogglePopup}>
            <div className="ap-popup-content" onClick={(e) => e.stopPropagation()}>
              <span className="ap-popup-close" onClick={handleTogglePopup}>
                &times;
              </span>
               <img
                 src={qrImage}
                 alt="NIECCE admission payment QR code"
                 title="NIECCE admission payment QR code"
                 className="ap-qr-image"
               />
              <p>Scan this QR code to pay / fill the application form</p>
              <div className="ap-popup-buttons">
                <button className="ap-popup-ok" onClick={handleTogglePopup}>
                  OK
                </button>
                <button className="ap-popup-open-form" onClick={() => {
                  handleTogglePopup();
                  handleOpenForm();
                }}>
                  Open Form
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="ap-notes">
          <p className="ap-note-title">Note:</p>
          <ol className="ap-note-list">
            <li>Keep ready the following: ID Card, 10th/12th/UG/PG certificates ready in JPEG or PDF format.</li>
            <li>Fill in the Application Form along with the Fee of Rs. 500/- for processing your application.</li>
            <li>Filling out the form doesn't guarantee Admission, it will just initiate the process.</li>
          </ol>
        </div>

        <div className="ap-seo-copy">
          <h2>How the teacher training admission process works</h2>
          <p>
            NIECCE keeps the admission process simple for learners joining a Montessori teacher training course, nursery teacher training course, or pre-primary teacher course. After submitting the application, our counsellor reviews the details and explains the course format, schedule, fees, and learning support available.
          </p>
          <p>
            Students receive guidance on document submission, payment confirmation, orientation, and class participation. Online and regular options help aspiring teachers choose a nursery teacher training process that fits their work, family, and career goals.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AdmissionProcess;
